import store from "../../app/store";
import trans from "../../app/trans";
import rootScope from "../../app/rootScope";

class SatRangeSwitchController{

    constructor(view) {
        this.view = view;

        this.addElements();

        this.view.bindSelect(this.select.bind(this));

    }

    addElements (){
        let oldValue = store.get("satelliteRange");
        const premium = store.get("premium");

        const range =  [...rootScope.satelliteRange];

        // if (! premium) {
        //     range.splice(3, 1);
        //     oldValue = oldValue === rootScope.satelliteRange[3] ? rootScope.satelliteRange[2] : oldValue;
        //     store.set("satelliteRange", oldValue);
        // }

        this.view.update(
            range.map(
                function(rangeValue){

                    return {
                        text: rangeValue,
                        value: rangeValue,
                        selected: rangeValue === oldValue,
                        premiumoption: ! premium && rangeValue >= 24
                    };
                }
            )

        );
    }

    select (value){
        store.set("satelliteRange", value);
    }

}

export default SatRangeSwitchController;
